const getExtensionFromMimeType = (mimeType: string) => {
  switch (mimeType) {
    case 'video/mp4':
    case 'audio/mp4':
      return 'mp4'
    case 'audio/wav':
      return 'wav'
    case 'audio/webm':
    case 'video/webm':
      return 'webm'
    case 'audio/ogg':
      return 'ogg'
  }
}

export { getExtensionFromMimeType }
